import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    memberType: '',
    // 一步存完你当前页面所有数据
    step1Data: {
      areaInfo: { name: '', id: '' },
      formData: {},
      previewImg: '',
      previewImg2: '',
    }
  },

  mutations: {
    SET_MEMBER_TYPE(state, memberType) {
      state.memberType = memberType
    },
    // 保存整个 step1 数据
    SET_STEP1_DATA(state, data) {
      state.step1Data = { ...state.step1Data, ...data }
    },
    // 清空（提交完用）
    CLEAR_STEP1(state) {
      state.memberType = ''
      state.step1Data = {
        areaInfo: { name: '', id: '' },
        formData: {},
        previewImg: '',
        previewImg2: '',
      }
    }
  },

  getters: {
    memberType: state => state.memberType,
    step1Data: state => state.step1Data
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js